module.exports = __webpack_public_path__ + "img/02.80a1415f.png";